import {createAction} from 'redux-act';
import {IStatsReducerState} from 'modules/reducers/stats';

export const fetchStats = createAction();
export const fetchStatsSuccess = createAction<IStatsReducerState>();
export const fetchStatsFailed = createAction();